import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ITopBarNotices } from '@okcargo-apps/layout-ionic';
import { AppTab } from '@okcargo-apps/shared-domain-ionic';
import { NoticeService } from './notice.service';

@Injectable({
  providedIn: 'root',
})
export class TopBarNoticesService implements ITopBarNotices {
  private readonly router = inject(Router);
  private readonly noticeService = inject(NoticeService);

  public readonly hasNotices = this.noticeService.hasNotices;

  public openNotices(): void {
    const targetElementId = 'pendingTasks';

    if (this.router.url.includes(`/tabs/${AppTab.DASHBOARD}`)) {
      this.scrollToElement(targetElementId);
    } else {
      this.router.navigate([`/tabs/${AppTab.DASHBOARD}`]).then(() => {
        setTimeout(() => this.scrollToElement(targetElementId), 200);
      });
    }
  }

  private scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
